import {EventEmitter, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {SysConfigService} from './sys-config.service';
import {NationalityModel} from '../dto/nationality.model';
import {AppConfig} from '../common/app.config';

@Injectable({
  providedIn: 'root'
})
export class NationalityService {
  nationalitySearchDetailsChange = new EventEmitter<NationalityModel[]>();
  private nationaliltySearchDetailsItem: NationalityModel[] = [];

  private headers = new HttpHeaders({
    'Content-Type': 'application/json; charset=utf-8'
  });


  constructor(private httpClient: HttpClient, private appConfig: AppConfig) {
  }

  public BASE_URL = this.appConfig.getConfig('BASE_URL') + 'api/';

  /** Save Nationality Details **/
  saveNationality(nationlityDTO: NationalityModel){
    return this.httpClient.post(this.BASE_URL + 'nationality/save' , nationlityDTO,{responseType: 'text'});
  }

  /** Get all nationality details **/
  getAllNationalities(){
    return this.httpClient.get(this.BASE_URL + 'nationality' + "/all")
  }

  /** Search Nationality Details **/
  searchNationalityDetails(nationalityDTO: NationalityModel){
    return this.httpClient.post(this.BASE_URL + 'nationality/search', nationalityDTO, { headers: this.headers });
  }

  /** Delete Nationality Details **/
  deleteNationalityDetails(code: string){
    return this.httpClient.delete(this.BASE_URL + 'nationality/delete/'+ code );
  }

  /** reset searched details **/
  clearNationalitySearchDetails() {
    this.nationaliltySearchDetailsItem = [];
    this.nationalitySearchDetailsChange.emit(this.nationaliltySearchDetailsItem);
  }

  /** set search details in the table **/
  setNationalitySearchDetails(nationalitySearchDetails: NationalityModel[]) {
    this.nationaliltySearchDetailsItem = nationalitySearchDetails;
    this.nationalitySearchDetailsChange.emit(this.nationaliltySearchDetailsItem);
  }
}
